export default () => ({
  loading: false,
  progress: false,
});
